import { render, staticRenderFns } from "./UserShops.vue?vue&type=template&id=cf796dde&"
import script from "./UserShops.vue?vue&type=script&lang=js&"
export * from "./UserShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports